import React from 'react';

class Games extends React.Component {
    render() {
        return (
            <div>
                <h1>Games Page</h1>
                <p>Content for the Games page.</p>
            </div>
        );
    }
}

export default Games;